<template>
  <div>
    
    <div class="discover text-center sec-top">
      <div class="container">
        <p class="head-title mg-t mg-b" 
            v-html="row.title1"
            :style="'color:'+row.titleColor1+' !important'"></p>
        <div class="sports">
          <img v-if="row.image1" :src="row.image1" :alt="row.title1">
        </div>
        <p class="title pad mg-t"
            v-html="row.content1"
            :style="'color:'+row.contentColor1+' !important'">
        </p>
        <router-link v-if="row.button1" :to="row.redirect1" class="btn-primary-o bwb-btn d-inline-block mg-t">
            <div class="d-flex align-items-center">
              {{ row.button1 }} 
              <span class="icon-arrow-right ml-2"></span>
            </div>
        </router-link>
      </div>
    </div>

  </div>
</template>

<style scoped>

</style>

<script>
export default {
  name: "Section1",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
